module.exports = __webpack_public_path__ + "static/media/EMA.e0eaffe5.svg";